import { useState } from 'react';
import { PermissionGuard } from '@/features/auth';
import { Pagination, SearchBar, ButtonLink } from '@/shared/components';
import { usePlansQuery } from '../hooks/usePlansQuery';
import { usePlanMutations } from '../hooks/usePlanMutations';
import { PlanDataTable } from '../components/PlanDataTable';

export function PlanList() {
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [search, setSearch] = useState('');

    const handleSearchChange = (value: string) => {
        setSearch(value);
        setPage(1);
    };

    const query = usePlansQuery({ page, per_page: perPage, search: search || undefined });
    const plans = query.data?.data ?? [];
    const lastPage = query.data?.last_page ?? 1;
    const total = query.data?.total ?? 0;
    const currentPage = query.data?.current_page ?? 1;
    const from = query.data?.from;
    const to = query.data?.to;

    const { deleteMutation } = usePlanMutations();

    return (
        <section className="space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Plans</h1>
                <PermissionGuard permission={{ resource: 'smr', action: 'plan.add' }}>
                    <ButtonLink to="/smr-admin/plans/new" size="sm">New Plan</ButtonLink>
                </PermissionGuard>
            </div>

            <SearchBar searchTerm={search} setSearchTerm={handleSearchChange} placeholder="Search plans..." />

            <div className="space-y-4">
                <PlanDataTable
                    data={plans}
                    isLoading={query.isLoading}
                    onDelete={(id) => deleteMutation.mutate(id)}
                />

                {lastPage > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        lastPage={lastPage}
                        total={total}
                        perPage={perPage}
                        from={from}
                        to={to}
                        onPageChange={setPage}
                        onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
                    />
                )}
            </div>
        </section>
    );
}
